// import { Badge, Box, Button, Drawer, DrawerBody, DrawerCloseButton, DrawerContent, DrawerFooter, DrawerHeader, DrawerOverlay, Flex, Grid, GridItem, Input, InputGroup, InputLeftElement, Select, Center, Spinner, Text, ModalOverlay, ModalHeader, ModalContent, ModalCloseButton, ModalBody, ModalFooter, Modal, FormControl, FormLabel, IconButton, Tooltip, } from '@chakra-ui/react';
// import MyDiv from './users.style';
// import { ChevronDownIcon, Search2Icon, TimeIcon } from '@chakra-ui/icons';
// import { AlertCard, CustomToast, CustomPagination, CustomTable } from '../../../../components';
// import { useEffect, useState } from 'react';
// import { useFetch } from '../../../../hooks/useFetch';
// import { IUser } from './model';
// import { MultiSelectMenu } from '../../../../components/MultiSelectMenu/MultiSelectMenu';
// import { Column } from '../../../../components/CustomTable/customTable';

// import { Table, Thead, Tbody, Tr, Th, Td, TableContainer, Tag, TagLabel, Wrap, WrapItem } from '@chakra-ui/react';
// import { useAuth } from '../../../../hooks/useAuth';

// interface IData {
//   users: IUser[];
//   totalCount: number;
// };

// type Employee = {
//   login_ID: number;
// };

// interface Option {
//   id: number;
//   role: string;
//   require_Branch: boolean;
//   require_Document_Upload_Payroll_Company: boolean;
//   require_Document_Upload_Us_Company: boolean;
// }

// const Users = () => {
//   const [users, setUsers] = useState<IUser[]>([]);
//   const [AlertOpen, setAlertOpen] = useState(false);
//   const [selectedId, setSelectedId] = useState<number | null>(null);
//   const [pendingStatus, setPendingStatus] = useState<boolean | null>(null);
//   const [selectedEmployee, setSelectedEmployee] = useState<Employee | null>(null);
//   const [isDrawerOpen, setIsDrawerOpen] = useState(false);
//   const [selectedRoles, setSelectedRoles] = useState<number[]>([]);
//   const [isAlertOpen, setIsAlertOpen] = useState(false);
//   const { addToast } = CustomToast();
//   const { hasPermission } = useAuth();
//   const [relationOption, setRelationOption] = useState<Option[]>([]);
//   const { fetchApi, loading } = useFetch(addToast);
//   const [totalCount, setTotalCount] = useState<number>(0);
//   const [searchQuery, setSearchQuery] = useState('');
//   const [lazyParams, setLazyParams] = useState({ first: 0, rows: 20, page: 0, sortField: '', sortOrder: 1, });
//   const [branches, setBranches] = useState<any[]>([]);
//   const [selectedBranch, setSelectedBranch] = useState<number[]>([]);
//   const [openPasswordModal, setOpenPasswordModal] = useState(false);
//   const [selectedEmpCredential, setSelectedEmpCredential] = useState<any>(null);
//   const [assignGroups, setAssignGroups] = useState<any[]>([]);
//   const [isSupportModalOpen, setIsSupportModalOpen] = useState(false);
//   const [selectedSupportGroups, setSelectedSupportGroups] = useState<number[]>([]);
//   const [selectedSupportEmployee, setSelectedSupportEmployee] = useState<any>(null);
//   const [departments, setDepartments] = useState<any[]>([]);
//   const [selectedDepartment, setSelectedDepartment] = useState<number | null>(null);

//   const [statusChangeSource, setStatusChangeSource] = useState<'table' | null>(null);
//   const getStatusColor = (status: boolean) => (status ? "#38A169" : "#E53E3E");
//   const pageCount = Math.ceil(totalCount / lazyParams.rows);
//   const [loadingstate, setloadingstate] = useState(false);
//   const [isHistoryModalOpen, setIsHistoryModalOpen] = useState(false);
//   const [roleChangeHistory, setRoleChangeHistory] = useState<any[]>([]);
//   const [historyLoading, setHistoryLoading] = useState(false);

//   const [payrollCompanies, setPayrollCompanies] = useState<any[]>([]);
//   const [usCompanies, setUsCompanies] = useState<any[]>([]);
//   const [selectedPayrollCompanies, setSelectedPayrollCompanies] = useState<number[]>([]);
//   const [selectedUsCompanies, setSelectedUsCompanies] = useState<number[]>([]);

//   const selectedRoleObjects = relationOption.filter(r => selectedRoles.includes(r.id));
//   const requireBranch = selectedRoleObjects.some(r => r.require_Branch);
//   const requirePayrollCompany = selectedRoleObjects.some(r => r.require_Document_Upload_Payroll_Company);
//   const requireUsCompany = selectedRoleObjects.some(r => r.require_Document_Upload_Us_Company);

//   const seeRoleChangeHistory = hasPermission('Users', 'seeRoleChangeHistory');

//   const handlePageClick = ({ selected }: { selected: number }) => {
//     const updatedParams = {
//       ...lazyParams,
//       page: selected,
//       first: selected * lazyParams.rows,
//     };
//     setLazyParams(updatedParams);
//   };

//   const loadUsers = async (filterValue = '') => {
//     setloadingstate(true);
//     const query = new URLSearchParams({
//       lazyParams: JSON.stringify(lazyParams),
//       filter: filterValue,
//     }).toString();
//     const response = await fetchApi<IData>('user', 'GET', null, query);

//     if (Array.isArray(response?.users)) {
//       setUsers(response?.users ?? []);
//       setTotalCount(response?.totalCount ?? 0);
//       setloadingstate(false);
//     } else {
//       setUsers([]);
//       setTotalCount(0);
//       setloadingstate(false);
//     }
//   };

//   useEffect(() => {
//     loadUsers();
//     fetchRoleOptions();
//     laodBranch();
//     loadAssignGroups();
//     loadDepartment();
//     loadPayrollCompany()
//     loadUsCompany()
//   }, [lazyParams]);

//   useEffect(() => {
//     const delayDebounce = setTimeout(() => {
//       loadUsers(searchQuery);
//     }, 400);

//     return () => clearTimeout(delayDebounce);
//   }, [searchQuery]);

//   const handleStatusChange = (roleId: number, newStatus: boolean) => {
//     setSelectedId(roleId);
//     setPendingStatus(newStatus);
//     setStatusChangeSource('table');
//     setAlertOpen(true);
//   };
//   const handleConfirmStatusChange = async () => {
//     if (selectedId !== null && pendingStatus !== null) {
//       const UserId = statusChangeSource === "table" ? selectedId : null;
//       const response = await fetchApi(`User/toggleStatus/${UserId}`, "PUT", { id: UserId, status: pendingStatus });
//       if (response) {
//         if (statusChangeSource === "table") {
//           setUsers((prev) => prev.map((users) => users.login_ID === selectedId ? { ...users, status: pendingStatus } : users));
//         } else {
//           console.log('object')
//         }
//       }
//     }
//     setAlertOpen(false);
//   };

//   type UpdateUserPayload = {
//     RoleIds: number[];
//     AssignedBranchIds: number[];
//     PayrollCompanyIds: number[];

//     UsCompanyIds: number[];
//     DepartmentId?: number; // optional
//   };



//   const loadRoleChangeHistory = async (empId: number) => {
//     setHistoryLoading(true);
//     const response = await fetchApi(`User/getroleChangeHistory?empId=${empId}`, "GET");
//     if (response) {
//       setRoleChangeHistory(response);
//     }
//     setHistoryLoading(false);
//   };


//   const handleConfirmUpdate = async () => {
//     if (!selectedEmployee) return;
//     if (selectedRoles.length === 0) {
//       addToast({ message: "Please select at least one role.", status: "error" });
//       return;
//     }
//     const isDeptHead = selectedRoles.includes(12);
//     if (requireBranch && (!selectedBranch || selectedBranch.length === 0)) {
//       addToast({ message: "Please select at least one branch.", status: "error" });
//       return;
//     }
//     if (isDeptHead && !selectedDepartment) {
//       addToast({ message: "Please select department.", status: "error" });
//       return;
//     }
//     if (requirePayrollCompany && selectedPayrollCompanies.length === 0) {
//       addToast({ message: "Please select Payroll Company.", status: "error" });
//       return;
//     }
//     if (requireUsCompany && selectedUsCompanies.length === 0) {
//       addToast({ message: "Please select  Company.", status: "error" });
//       return;
//     }
//     const payload: UpdateUserPayload = {
//       RoleIds: selectedRoles,
//       AssignedBranchIds: selectedBranch,
//       PayrollCompanyIds: selectedPayrollCompanies,
//       UsCompanyIds: selectedUsCompanies
//     };

//     if (selectedRoles.includes(12)) {
//       if (!selectedDepartment) {
//         addToast({ message: "Please select department.", status: "error" });
//         return;
//       }
//       payload.DepartmentId = selectedDepartment;
//     }
//     const response = await fetchApi(`User/updateroles/${selectedEmployee.login_ID}`, "PUT", payload);
//     if (response) {
//       addToast({ message: "Roles updated successfully.", status: "success" });
//       loadUsers();
//     }
//     setSelectedEmployee(null);
//     setIsDrawerOpen(false);
//     setIsAlertOpen(false);
//   };


//   const fetchRoleOptions = async () => {
//     const response = await fetchApi("DropDown/role", "GET", null, "", "");
//     if (response) {
//       setRelationOption(response);
//     }
//   }
//   const laodBranch = async () => {
//     const response = await fetchApi("Dropdown/branchWithCompany", "GET", "", "", "");
//     if (response) {
//       setBranches(response);
//     }
//   }
//   const loadDepartment = async () => {
//     const response = await fetchApi("DropDown/department", "GET");
//     if (response) {
//       setDepartments(response);
//     }
//   };

//   const loadPayrollCompany = async () => {
//     const response = await fetchApi("DropDown/payrollCompany", "GET");
//     if (response) {
//       setPayrollCompanies(response);
//     }
//   };

//   const loadUsCompany = async () => {
//     const response = await fetchApi("DropDown/company", "GET");
//     if (response) {
//       setUsCompanies(response);
//     }
//   }




//   const loadAssignGroups = async () => {
//     const response = await fetchApi("DropDown/supportAssignGroup", "GET");
//     if (response) setAssignGroups(response);
//   };

//   const openSupportModal = (emp: any) => {
//     setSelectedSupportEmployee(emp);
//     setSelectedSupportGroups(emp.assignedGroups?.map((g: any) => g.ticket_Group_Id) || []);
//     setIsSupportModalOpen(true);
//     loadAssignGroups();
//   };
//   useEffect(() => {
//     if (!selectedRoles.includes(12)) {
//       setSelectedDepartment(null);
//     }
//   }, [selectedRoles]);


//   const submitSupportGroup = async () => {
//     const payload = {
//       employeeId: selectedSupportEmployee.login_ID,
//       groupIds: selectedSupportGroups
//     };

//     const res = await fetchApi("Support/AssignGroup", "POST", payload);
//     if (res) {
//       addToast({ message: "Support groups assigned successfully", status: "success" });
//       setIsSupportModalOpen(false);
//       loadUsers();
//     }
//   }

//   return (
//     <MyDiv>
//       <Flex className="page_heading flex_header" justifyContent="space-between" alignItems="center">
//         <Text className="font-poppins text_semibold text_3xl">Users</Text>

//         <Flex gap="10px" alignItems="center">
//           <InputGroup width="217px" height="37px">
//             <InputLeftElement pointerEvents="none">
//               <Search2Icon color="rgba(102, 112, 133, 1)" />
//             </InputLeftElement>
//             <Input type="text" className='font-poppins text_regular text_md' placeholder="Search By UserName...." maxW="400px" onChange={(e) => setSearchQuery(e.target.value)} />
//           </InputGroup>

//         </Flex>
//       </Flex>
//       <Grid className='grid_container'>
//         <GridItem colSpan={12}>
//           <Box position="relative" minH="300px">
//             {loadingstate ? (
//               <Center position="absolute" top={0} left={0} right={0} bottom={0}>
//                 <Spinner thickness="4px" speed="0.65s" emptyColor="gray.200" color="#006838" size="xl" />
//               </Center>) : (
//               <>
//                 <CustomTable value={users} loading={loadingstate} emptyMessage="No users found.">
//                   <Column header="S.No" body={(_, index) => index + 1} />
//                   <Column header="Emp. Code" field="employeeCode" />
//                   <Column header="Name" body={(emp: any) => (<Badge variant="subtle" className="empId font-poppins text_sm text_regular" onClick={() => { setOpenPasswordModal(true); setSelectedEmpCredential(emp); }}>{emp.name}</Badge>)} />
//                   <Column header="Company" field='company' />
//                   <Column header="Payroll Company" field='payrollCompany' />
//                   <Column header="Branch" field='branch' />
//                   <Column header="Department" field='department' />
//                   <Column header="Designation" field='designation' />
//                   <Column header="Shift" field='shift' />
//                   <Column header="Role" body={(emp: IUser) => {
//                     if (!emp.roles || emp.roles.length === 0) {
//                       return (
//                         <Text cursor="pointer" color="gray.500" className="font-poppins text_sm text_regular" onClick={() => {
//                           setSelectedEmployee(emp);
//                           setSelectedRoles([]);
//                           setSelectedBranch(emp.assignedBranches?.map((b: any) => b.branch_ID) || []);
//                           setSelectedPayrollCompanies(emp.assignedPayrollCompanies?.map((pc: any) => pc.payroll_Company_Id) || []);
//                           setSelectedUsCompanies(emp.assignedUsCompanies?.map((uc: any) => uc.company_Id) || []);
//                           setSelectedDepartment(emp.departmentId || null);
//                           setIsDrawerOpen(true);
//                         }}>
//                           —
//                         </Text>
//                       );
//                     }

//                     return (
//                       <Flex direction="column" gap="2px">
//                         {Array.from({ length: Math.ceil(emp.roles.length / 2) }).map((_, rowIndex) => (
//                           <Flex key={rowIndex} direction="row" gap="12px">
//                             {emp.roles.slice(rowIndex * 2, rowIndex * 2 + 2).map((role) => (
//                               <Badge key={role.id} textAlign="center" className="bdg font-poppins text_sm text_regular" mr={1} mb={1} textTransform="none" onClick={() => {
//                                 setSelectedEmployee(emp);
//                                 setSelectedRoles(emp.roles.map(r => r.id));
//                                 setSelectedBranch(emp.assignedBranches?.map((b: any) => b.branch_ID) || []);
//                                 setSelectedPayrollCompanies(emp.assignedPayrollCompanies?.map((pc: any) => pc.payrollCompany_ID) || []);
//                                 setSelectedUsCompanies(emp.assignedUsCompanies?.map((uc: any) => uc.usCompany_ID) || []);
//                                 setIsDrawerOpen(true);
//                               }}
//                               >
//                                 • {role.name}
//                               </Badge>
//                             ))}
//                           </Flex>
//                         ))}
//                       </Flex>
//                     );
//                   }}
//                   />

//                   <Column header="Support" body={(emp: IUser) => {
//                     if (!emp.assignedGroups || emp.assignedGroups.length === 0) {
//                       return (
//                         <Text cursor="pointer" color="gray.500" onClick={() => openSupportModal(emp)} className="font-poppins text_sm text_regular" > — </Text>
//                       );
//                     }

//                     return (
//                       <Flex direction="column" gap="2px">
//                         {Array.from({ length: Math.ceil(emp.assignedGroups.length / 2) }).map((_, rowIndex) => (
//                           <Flex key={rowIndex} direction="row" gap="12px">
//                             {emp.assignedGroups.slice(rowIndex * 2, rowIndex * 2 + 2).map((assignedGroups) => (
//                               <Badge key={assignedGroups.ticket_Group_Id} className="bdg font-poppins text_sm text_regular" textTransform="none" onClick={() => openSupportModal(emp)} >
//                                 • {assignedGroups.ticket_Group_Name}
//                               </Badge>
//                             ))}
//                           </Flex>
//                         ))}
//                       </Flex>
//                     );
//                   }} />

//                   <Column header="Status " body={(emp: IUser) => (
//                     <Select value={emp.status ? "true" : "false"} onChange={(e) => handleStatusChange(emp.login_ID, e.target.value === "true")} width="120px" height="32px" icon={<ChevronDownIcon />} borderRadius="4px" color={getStatusColor(emp.status)} className="font-poppins text_medium text_xsm">
//                       <option value="true" style={{ color: "#38A169" }}>Active</option>
//                       <option value="false" style={{ color: "#E53E3E" }}>Inactive</option>
//                     </Select>
//                   )}
//                   />

//                   {seeRoleChangeHistory && (
//                     <Column header="Action" body={(emp: IUser) => (
//                       <Tooltip label="View History" placement="top">
//                         <IconButton size="xs" colorScheme="blue" variant="outline" aria-label="History" icon={<TimeIcon />} onClick={() => { setIsHistoryModalOpen(true); loadRoleChangeHistory(emp.login_ID); }} />
//                       </Tooltip>
//                     )}
//                     />
//                   )}

//                 </CustomTable>
//               </>)}
//           </Box>
//         </GridItem>
//       </Grid>
//       <AlertCard isOpen={AlertOpen} onClose={() => setAlertOpen(false)} onConfirm={handleConfirmStatusChange} />

//       <Drawer isOpen={isDrawerOpen} onClose={() => setIsDrawerOpen(false)} placement="right" size="sm">
//         <DrawerOverlay />
//         <DrawerContent className='font-poppins text_md text_regular'>
//           <DrawerCloseButton />
//           <DrawerHeader borderBottomWidth="1px">Update User Role</DrawerHeader>
//           <DrawerBody>
//             <MultiSelectMenu label="Select Roles" options={relationOption} selectedValues={selectedRoles} setSelectedValues={setSelectedRoles} labelKey="role" valueKey="id" />
//             {requireBranch && (
//               <MultiSelectMenu label="Assigned Branches" ShowNumberOfTiles={1} placeholder="Select Branch" overflow options={branches} selectedValues={selectedBranch} setSelectedValues={setSelectedBranch} labelKey="branchName" valueKey="branchId" />
//             )}
//             {selectedRoles.includes(12) && (
//               <FormControl mt={4}>
//                 <FormLabel>Select Department</FormLabel>
//                 <Select placeholder="Select Department" value={selectedDepartment ?? ""} onChange={(e) => setSelectedDepartment(Number(e.target.value))} >
//                   {departments.map((dept) => (<option key={dept.id} value={dept.id}>{dept.departmentName}</option>))}
//                 </Select>
//               </FormControl>
//             )}
//             {requirePayrollCompany && (
//               <MultiSelectMenu label="Payroll Companies" options={payrollCompanies} selectedValues={selectedPayrollCompanies} setSelectedValues={setSelectedPayrollCompanies} labelKey="payroll_Company_Name" valueKey="id" />
//             )}
//             {requireUsCompany && (
//               <MultiSelectMenu label="Companies" options={usCompanies} selectedValues={selectedUsCompanies} setSelectedValues={setSelectedUsCompanies} labelKey="company_Name" valueKey="company_ID" />
//             )}
//           </DrawerBody>
//           <DrawerFooter>
//             <Button colorScheme="green" onClick={() => { setIsAlertOpen(true); }}>
//               Update
//             </Button>
//           </DrawerFooter>
//         </DrawerContent>
//       </Drawer>

//       <Modal isOpen={openPasswordModal} onClose={() => { setOpenPasswordModal(false); setSelectedEmpCredential(null); }} isCentered size="xl">
//         <ModalOverlay />
//         <ModalContent borderRadius="2xl" boxShadow="xl" className="font-poppins text_md text_regular">
//           <ModalHeader textAlign="center" fontWeight="600" fontSize="xl" borderBottom="1px solid #E2E8F0" py={3} >Employee Credential</ModalHeader>
//           <ModalCloseButton />
//           <ModalBody py={5}>
//             {selectedEmpCredential ? (
//               <Box display="flex" flexDirection="column" gap={4} px={2}>
//                 <Box display="flex" justifyContent="space-between" alignItems="center">
//                   <Text fontWeight="500" color="gray.600">Username:</Text>
//                   <Text color="blue.600" fontWeight="600">{selectedEmpCredential.email}</Text>
//                 </Box>
//                 <Box display="flex" justifyContent="space-between" alignItems="center">
//                   <Text fontWeight="500" color="gray.600">Password:</Text>
//                   <Text color="green.600" fontWeight="600">{selectedEmpCredential.login_Password}</Text>
//                 </Box>
//               </Box>
//             ) : (
//               <Text textAlign="center" color="gray.500">No credentials available.</Text>
//             )}
//           </ModalBody>
//           <ModalFooter borderTop="1px solid #E2E8F0" display="flex" justifyContent="space-between" >
//           </ModalFooter>
//         </ModalContent>
//       </Modal>

//       <Modal isOpen={isSupportModalOpen} onClose={() => setIsSupportModalOpen(false)} isCentered size="lg" >
//         <ModalOverlay />
//         <ModalContent className="font-poppins text_md text_regular">
//           <ModalHeader>Assign Support Groups</ModalHeader>
//           <ModalCloseButton />
//           <ModalBody>
//             <MultiSelectMenu label="Select Support Groups" options={assignGroups} selectedValues={selectedSupportGroups} setSelectedValues={setSelectedSupportGroups} labelKey="assign_Group_Name" valueKey="assign_Group_Id" />
//           </ModalBody>
//           <ModalFooter>
//             <Button colorScheme="green" onClick={submitSupportGroup} >Assign</Button>
//           </ModalFooter>
//         </ModalContent>
//       </Modal>

//       <Modal isOpen={isHistoryModalOpen} onClose={() => setIsHistoryModalOpen(false)} isCentered size="5xl" scrollBehavior="inside">
//         <ModalOverlay />
//         <ModalContent className="font-poppins text_md text_regular">
//           <ModalHeader borderBottom="1px solid #E2E8F0">
//             Role Change History
//             {roleChangeHistory.length > 0 && (
//               <Text fontSize="sm" color="gray.500" fontWeight="400">
//                 {roleChangeHistory[0]?.employee_Name} (ID: {roleChangeHistory[0]?.login_ID})
//               </Text>
//             )}
//           </ModalHeader>
//           <ModalCloseButton />
//           <ModalBody py={4}>
//             {historyLoading ? (
//               <Center py={10}>
//                 <Spinner thickness="4px" speed="0.65s" emptyColor="gray.200" color="#006838" size="xl" />
//               </Center>
//             ) : roleChangeHistory.length === 0 ? (
//               <Text textAlign="center" color="gray.500">No history found.</Text>
//             ) : (
//               <TableContainer>
//                 <Table variant="simple" size="sm">
//                   <Thead bg="gray.50">
//                     <Tr>
//                       <Th>Emp ID</Th>
//                       <Th>Employee</Th>
//                       <Th>Changed By</Th>
//                       <Th>Old Roles</Th>
//                       <Th>New Roles</Th>
//                       <Th>Added</Th>
//                       <Th>Removed</Th>
//                       <Th>Date & Time</Th>
//                     </Tr>
//                   </Thead>
//                   <Tbody>
//                     {roleChangeHistory.map((log, index) => (
//                       <Tr key={index} _hover={{ bg: "gray.50" }}>
//                         <Td>{log.login_ID}</Td>
//                         <Td fontWeight="500">{log.employee_Name}</Td>
//                         <Td>{log.changed_By}</Td>
//                         <Td>
//                           <Wrap>
//                             {log.old_Roles?.map((r: string, i: number) => (
//                               <WrapItem key={i}><Tag size="sm" colorScheme="gray"><TagLabel>{r}</TagLabel></Tag></WrapItem>
//                             ))}
//                           </Wrap>
//                         </Td>
//                         <Td>
//                           <Wrap>
//                             {log.new_Roles?.map((r: string, i: number) => (
//                               <WrapItem key={i}><Tag size="sm" colorScheme="blue"><TagLabel>{r}</TagLabel></Tag></WrapItem>
//                             ))}
//                           </Wrap>
//                         </Td>
//                         <Td>
//                           <Wrap>
//                             {log.added_Roles?.map((r: string, i: number) => (
//                               <WrapItem key={i}><Tag size="sm" colorScheme="green"><TagLabel>+ {r}</TagLabel></Tag></WrapItem>
//                             ))}
//                           </Wrap>
//                         </Td>
//                         <Td>
//                           <Wrap>
//                             {log.removed_Roles?.map((r: string, i: number) => (
//                               <WrapItem key={i}><Tag size="sm" colorScheme="red"><TagLabel>- {r}</TagLabel></Tag></WrapItem>
//                             ))}
//                           </Wrap>
//                         </Td>
//                         <Td whiteSpace="nowrap">
//                           {new Date(log.changed_At).toLocaleString('en-IN', {
//                             day: '2-digit', month: 'short', year: 'numeric',
//                             hour: '2-digit', minute: '2-digit'
//                           })}
//                         </Td>
//                       </Tr>
//                     ))}
//                   </Tbody>
//                 </Table>
//               </TableContainer>
//             )}
//           </ModalBody>
//           <ModalFooter borderTop="1px solid #E2E8F0">
//             <Button onClick={() => setIsHistoryModalOpen(false)}>Close</Button>
//           </ModalFooter>
//         </ModalContent>
//       </Modal>

//       <AlertCard isOpen={isAlertOpen} onClose={() => setIsAlertOpen(false)} onConfirm={handleConfirmUpdate} title="Update Role" description="Are you Sure you want to update role?" confirmLabel='Confirm' cancelLabel='Cancel' colorScheme='green' />
//       <CustomPagination pageCount={pageCount} handlePageClick={handlePageClick} rowsPerPage={lazyParams.rows} rowsPerPageOptions={[20, 50, 100, 200]} setRowsPerPage={(value: number) => setLazyParams((prev) => ({ ...prev, rows: value, page: 0, first: 0 }))} totalRecords={totalCount} currentPage={lazyParams.page} />

//     </MyDiv>
//   );
// };

// export default Users;



import { Badge, Box, Button, Drawer, DrawerBody, DrawerCloseButton, DrawerContent, DrawerFooter, DrawerHeader, DrawerOverlay, Flex, Grid, GridItem, Select, Center, Spinner, Text, ModalOverlay, ModalHeader, ModalContent, ModalCloseButton, ModalBody, ModalFooter, Modal, FormControl, FormLabel, IconButton, Tooltip, } from '@chakra-ui/react';
import MyDiv from './users.style';
import { ChevronDownIcon, TimeIcon } from '@chakra-ui/icons';
import { AlertCard, CustomToast } from '../../../../components';
import { useEffect, useState } from 'react';
import { useFetch } from '../../../../hooks/useFetch';
import { IUser } from './model';
import { MultiSelectMenu } from '../../../../components/MultiSelectMenu/MultiSelectMenu';
import CustomTables, { Column, ILazyParams } from '../../../../components/CustomTable/CustomTables';

import { Table, Thead, Tbody, Tr, Th, Td, TableContainer, Tag, TagLabel, Wrap, WrapItem } from '@chakra-ui/react';
import { useAuth } from '../../../../hooks/useAuth';

interface IData {
  users: IUser[];
  totalCount: number;
}

type Employee = { login_ID: number };

interface Option {
  id: number;
  role: string;
  require_Branch: boolean;
  require_Document_Upload_Payroll_Company: boolean;
  require_Document_Upload_Us_Company: boolean;
}

const Users = () => {
  const [users, setUsers] = useState<IUser[]>([]);
  const [AlertOpen, setAlertOpen] = useState(false);
  const [selectedId, setSelectedId] = useState<number | null>(null);
  const [pendingStatus, setPendingStatus] = useState<boolean | null>(null);
  const [selectedEmployee, setSelectedEmployee] = useState<Employee | null>(null);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [selectedRoles, setSelectedRoles] = useState<number[]>([]);
  const [isAlertOpen, setIsAlertOpen] = useState(false);
  const { addToast } = CustomToast();
  const { hasPermission } = useAuth();
  const [relationOption, setRelationOption] = useState<Option[]>([]);
  const { fetchApi } = useFetch(addToast);
  const [totalCount, setTotalCount] = useState<number>(0);

  // Unified lazyParams — same shape CustomTables emits via onLazyParamsChange
  const [lazyParams, setLazyParams] = useState<ILazyParams>({
    first: 0,
    rows: 20,
    sortField: undefined,
    sortOrder: undefined,
    multiSortMeta: [],
    filters: {},
    globalFilter: '',
  });

  const [branches, setBranches] = useState<any[]>([]);
  const [selectedBranch, setSelectedBranch] = useState<number[]>([]);
  const [openPasswordModal, setOpenPasswordModal] = useState(false);
  const [selectedEmpCredential, setSelectedEmpCredential] = useState<any>(null);
  const [assignGroups, setAssignGroups] = useState<any[]>([]);
  const [isSupportModalOpen, setIsSupportModalOpen] = useState(false);
  const [selectedSupportGroups, setSelectedSupportGroups] = useState<number[]>([]);
  const [selectedSupportEmployee, setSelectedSupportEmployee] = useState<any>(null);
  const [departments, setDepartments] = useState<any[]>([]);
  const [selectedDepartment, setSelectedDepartment] = useState<number | null>(null);

  const [statusChangeSource, setStatusChangeSource] = useState<'table' | null>(null);
  const getStatusColor = (status: boolean) => (status ? "#38A169" : "#E53E3E");
  const [loadingstate, setloadingstate] = useState(false);
  const [isHistoryModalOpen, setIsHistoryModalOpen] = useState(false);
  const [roleChangeHistory, setRoleChangeHistory] = useState<any[]>([]);
  const [historyLoading, setHistoryLoading] = useState(false);

  const [payrollCompanies, setPayrollCompanies] = useState<any[]>([]);
  const [usCompanies, setUsCompanies] = useState<any[]>([]);
  const [selectedPayrollCompanies, setSelectedPayrollCompanies] = useState<number[]>([]);
  const [selectedUsCompanies, setSelectedUsCompanies] = useState<number[]>([]);

  const selectedRoleObjects = relationOption.filter(r => selectedRoles.includes(r.id));
  const requireBranch = selectedRoleObjects.some(r => r.require_Branch);
  const requirePayrollCompany = selectedRoleObjects.some(r => r.require_Document_Upload_Payroll_Company);
  const requireUsCompany = selectedRoleObjects.some(r => r.require_Document_Upload_Us_Company);

  const seeRoleChangeHistory = hasPermission('Users', 'seeRoleChangeHistory');

  const loadUsers = async () => {
    setloadingstate(true);

    const params = new URLSearchParams();
    params.set('first', String(lazyParams.first));
    params.set('rows', String(lazyParams.rows));
    if (lazyParams.sortField) params.set('sortField', lazyParams.sortField);
    if (lazyParams.sortOrder) params.set('sortOrder', String(lazyParams.sortOrder));
    if (lazyParams.globalFilter) params.set('globalFilter', lazyParams.globalFilter);
    if (lazyParams.filters && Object.keys(lazyParams.filters).length) {
      params.set('filters', JSON.stringify(lazyParams.filters));
    }

    const response = await fetchApi<IData>('user', 'GET', null, params.toString());

    if (Array.isArray(response?.users)) {
      setUsers(response?.users ?? []);
      setTotalCount(response?.totalCount ?? 0);
    } else {
      setUsers([]);
      setTotalCount(0);
    }
    setloadingstate(false);
  };

  useEffect(() => {
    loadUsers();
  }, [lazyParams]);

  useEffect(() => {
    fetchRoleOptions();
    laodBranch();
    loadAssignGroups();
    loadDepartment();
    loadPayrollCompany();
    loadUsCompany();
  }, []);

  const handleStatusChange = (roleId: number, newStatus: boolean) => {
    setSelectedId(roleId);
    setPendingStatus(newStatus);
    setStatusChangeSource('table');
    setAlertOpen(true);
  };

  const handleConfirmStatusChange = async () => {
    if (selectedId !== null && pendingStatus !== null) {
      const UserId = statusChangeSource === "table" ? selectedId : null;
      const response = await fetchApi(`User/toggleStatus/${UserId}`, "PUT", { id: UserId, status: pendingStatus });
      if (response) {
        if (statusChangeSource === "table") {
          setUsers((prev) => prev.map((u) => u.login_ID === selectedId ? { ...u, status: pendingStatus } : u));
        }
      }
    }
    setAlertOpen(false);
  };

  type UpdateUserPayload = {
    RoleIds: number[];
    AssignedBranchIds: number[];
    PayrollCompanyIds: number[];
    UsCompanyIds: number[];
    DepartmentId?: number;
  };

  const loadRoleChangeHistory = async (empId: number) => {
    setHistoryLoading(true);
    const response = await fetchApi(`User/getroleChangeHistory?empId=${empId}`, "GET");
    if (response) setRoleChangeHistory(response);
    setHistoryLoading(false);
  };

  const handleConfirmUpdate = async () => {
    if (!selectedEmployee) return;
    if (selectedRoles.length === 0) {
      addToast({ message: "Please select at least one role.", status: "error" });
      return;
    }
    const isDeptHead = selectedRoles.includes(12);
    if (requireBranch && (!selectedBranch || selectedBranch.length === 0)) {
      addToast({ message: "Please select at least one branch.", status: "error" });
      return;
    }
    if (isDeptHead && !selectedDepartment) {
      addToast({ message: "Please select department.", status: "error" });
      return;
    }
    if (requirePayrollCompany && selectedPayrollCompanies.length === 0) {
      addToast({ message: "Please select Payroll Company.", status: "error" });
      return;
    }
    if (requireUsCompany && selectedUsCompanies.length === 0) {
      addToast({ message: "Please select  Company.", status: "error" });
      return;
    }
    const payload: UpdateUserPayload = {
      RoleIds: selectedRoles,
      AssignedBranchIds: selectedBranch,
      PayrollCompanyIds: selectedPayrollCompanies,
      UsCompanyIds: selectedUsCompanies
    };

    if (selectedRoles.includes(12)) {
      if (!selectedDepartment) {
        addToast({ message: "Please select department.", status: "error" });
        return;
      }
      payload.DepartmentId = selectedDepartment;
    }
    const response = await fetchApi(`User/updateroles/${selectedEmployee.login_ID}`, "PUT", payload);
    if (response) {
      addToast({ message: "Roles updated successfully.", status: "success" });
      loadUsers();
    }
    setSelectedEmployee(null);
    setIsDrawerOpen(false);
    setIsAlertOpen(false);
  };

  const fetchRoleOptions = async () => {
    const response = await fetchApi("DropDown/role", "GET", null, "", "");
    if (response) setRelationOption(response);
  };
  const laodBranch = async () => {
    const response = await fetchApi("Dropdown/branchWithCompany", "GET", "", "", "");
    if (response) setBranches(response);
  };
  const loadDepartment = async () => {
    const response = await fetchApi("DropDown/department", "GET");
    if (response) setDepartments(response);
  };
  const loadPayrollCompany = async () => {
    const response = await fetchApi("DropDown/payrollCompany", "GET");
    if (response) setPayrollCompanies(response);
  };
  const loadUsCompany = async () => {
    const response = await fetchApi("DropDown/company", "GET");
    if (response) setUsCompanies(response);
  };

  const loadAssignGroups = async () => {
    const response = await fetchApi("DropDown/supportAssignGroup", "GET");
    if (response) setAssignGroups(response);
  };

  const openSupportModal = (emp: any) => {
    setSelectedSupportEmployee(emp);
    setSelectedSupportGroups(emp.assignedGroups?.map((g: any) => g.ticket_Group_Id) || []);
    setIsSupportModalOpen(true);
    loadAssignGroups();
  };

  useEffect(() => {
    if (!selectedRoles.includes(12)) setSelectedDepartment(null);
  }, [selectedRoles]);

  const submitSupportGroup = async () => {
    const payload = {
      employeeId: selectedSupportEmployee.login_ID,
      groupIds: selectedSupportGroups
    };
    const res = await fetchApi("Support/AssignGroup", "POST", payload);
    if (res) {
      addToast({ message: "Support groups assigned successfully", status: "success" });
      setIsSupportModalOpen(false);
      loadUsers();
    }
  };

  return (
    <MyDiv>
      <Flex className="page_heading flex_header" justifyContent="space-between" alignItems="center">
        <Text className="font-poppins text_semibold text_3xl">Users</Text>
      </Flex>
      <Grid className='grid_container'>
        <GridItem colSpan={12}>
          <Box position="relative" minH="300px">
            <CustomTables<IUser>
              value={users}
              loading={loadingstate}
              emptyMessage="No users found."
              preferenceKey="usersTable"
              globalSearchPlaceholder="Search By UserName…."
              lazy
              lazyParams={lazyParams}
              onLazyParamsChange={setLazyParams}
              totalRecords={totalCount}
              showPagination
              rowsPerPageOptions={[20, 50, 100, 200]}
              maxTableHeight={null}
            >
              {/* <Column header="S.No" body={(_, index) => index + 1} /> */}
              <Column header="Emp. Code" field="employeeCode" sortable filterable filterType="text" frozen="left" />
              <Column header="Name" field="name" sortable filterable filterType="text" frozen="left" body={(emp: any) => (<Badge variant="subtle" className="empId font-poppins text_sm text_regular" onClick={() => { setOpenPasswordModal(true); setSelectedEmpCredential(emp); }}>{emp.name}</Badge>)} />
              <Column header="Company" field='company' sortable filterable filterType="text" />
              <Column header="Payroll Company" field='payrollCompany' sortable filterable filterType="text" />
              <Column header="Branch" field='branch' sortable filterable filterType="text" />
              <Column header="Department" field='department' sortable filterable filterType="text" />
              <Column header="Designation" field='designation' sortable filterable filterType="text" />
              <Column header="Shift" field='shift' sortable filterable filterType="text" />
              <Column header="Role" body={(emp: IUser) => {
                if (!emp.roles || emp.roles.length === 0) {
                  return (
                    <Text cursor="pointer" color="gray.500" className="font-poppins text_sm text_regular" onClick={() => {
                      setSelectedEmployee(emp);
                      setSelectedRoles([]);
                      setSelectedBranch(emp.assignedBranches?.map((b: any) => b.branch_ID) || []);
                      setSelectedPayrollCompanies(emp.assignedPayrollCompanies?.map((pc: any) => pc.payroll_Company_Id) || []);
                      setSelectedUsCompanies(emp.assignedUsCompanies?.map((uc: any) => uc.company_Id) || []);
                      setSelectedDepartment(emp.departmentId || null);
                      setIsDrawerOpen(true);
                    }}>
                      —
                    </Text>
                  );
                }
                return (
                  <Flex direction="column" gap="2px">
                    {Array.from({ length: Math.ceil(emp.roles.length / 2) }).map((_, rowIndex) => (
                      <Flex key={rowIndex} direction="row" gap="12px">
                        {emp.roles.slice(rowIndex * 2, rowIndex * 2 + 2).map((role) => (
                          <Badge key={role.id} textAlign="center" className="bdg font-poppins text_sm text_regular" mr={1} mb={1} textTransform="none" onClick={() => {
                            setSelectedEmployee(emp);
                            setSelectedRoles(emp.roles.map(r => r.id));
                            setSelectedBranch(emp.assignedBranches?.map((b: any) => b.branch_ID) || []);
                            setSelectedPayrollCompanies(emp.assignedPayrollCompanies?.map((pc: any) => pc.payroll_Company_Id) || []);
                            setSelectedUsCompanies(emp.assignedUsCompanies?.map((uc: any) => uc.company_ID) || []);
                            setIsDrawerOpen(true);
                          }}
                          >
                            • {role.name}
                          </Badge>
                        ))}
                      </Flex>
                    ))}
                  </Flex>
                );
              }} />

              <Column header="Support" body={(emp: IUser) => {
                if (!emp.assignedGroups || emp.assignedGroups.length === 0) {
                  return (<Text cursor="pointer" color="gray.500" onClick={() => openSupportModal(emp)} className="font-poppins text_sm text_regular"> — </Text>);
                }
                return (
                  <Flex direction="column" gap="2px">
                    {Array.from({ length: Math.ceil(emp.assignedGroups.length / 2) }).map((_, rowIndex) => (
                      <Flex key={rowIndex} direction="row" gap="12px">
                        {emp.assignedGroups.slice(rowIndex * 2, rowIndex * 2 + 2).map((assignedGroups) => (
                          <Badge key={assignedGroups.ticket_Group_Id} className="bdg font-poppins text_sm text_regular" textTransform="none" onClick={() => openSupportModal(emp)}>
                            • {assignedGroups.ticket_Group_Name}
                          </Badge>
                        ))}
                      </Flex>
                    ))}
                  </Flex>
                );
              }} />

              <Column header="Status" field="status" filterable filterType="boolean" body={(emp: IUser) => (
                <Select value={emp.status ? "true" : "false"} onChange={(e) => handleStatusChange(emp.login_ID, e.target.value === "true")} width="120px" height="32px" icon={<ChevronDownIcon />} borderRadius="4px" color={getStatusColor(emp.status)} className="font-poppins text_medium text_xsm">
                  <option value="true" style={{ color: "#38A169" }}>Active</option>
                  <option value="false" style={{ color: "#E53E3E" }}>Inactive</option>
                </Select>
              )} />

              {seeRoleChangeHistory && (
                <Column header="Action" body={(emp: IUser) => (
                  <Tooltip label="View History" placement="top">
                    <IconButton size="xs" colorScheme="blue" variant="outline" aria-label="History" icon={<TimeIcon />} onClick={() => { setIsHistoryModalOpen(true); loadRoleChangeHistory(emp.login_ID); }} />
                  </Tooltip>
                )} />
              )}
            </CustomTables>
          </Box>
        </GridItem>
      </Grid>

      <AlertCard isOpen={AlertOpen} onClose={() => setAlertOpen(false)} onConfirm={handleConfirmStatusChange} />

      <Drawer isOpen={isDrawerOpen} onClose={() => setIsDrawerOpen(false)} placement="right" size="sm">
        <DrawerOverlay />
        <DrawerContent className='font-poppins text_md text_regular'>
          <DrawerCloseButton />
          <DrawerHeader borderBottomWidth="1px">Update User Role</DrawerHeader>
          <DrawerBody>
            <MultiSelectMenu label="Select Roles" options={relationOption} selectedValues={selectedRoles} setSelectedValues={setSelectedRoles} labelKey="role" valueKey="id" />
            {requireBranch && (
              <MultiSelectMenu label="Assigned Branches" ShowNumberOfTiles={1} placeholder="Select Branch" overflow options={branches} selectedValues={selectedBranch} setSelectedValues={setSelectedBranch} labelKey="branchName" valueKey="branchId" />
            )}
            {selectedRoles.includes(12) && (
              <FormControl mt={4}>
                <FormLabel>Select Department</FormLabel>
                <Select placeholder="Select Department" value={selectedDepartment ?? ""} onChange={(e) => setSelectedDepartment(Number(e.target.value))}>
                  {departments.map((dept) => (<option key={dept.id} value={dept.id}>{dept.departmentName}</option>))}
                </Select>
              </FormControl>
            )}
            {requirePayrollCompany && (
              <MultiSelectMenu label="Payroll Companies" options={payrollCompanies} selectedValues={selectedPayrollCompanies} setSelectedValues={setSelectedPayrollCompanies} labelKey="payroll_Company_Name" valueKey="id" />
            )}
            {requireUsCompany && (
              <MultiSelectMenu label="Companies" options={usCompanies} selectedValues={selectedUsCompanies} setSelectedValues={setSelectedUsCompanies} labelKey="company_Name" valueKey="company_ID" />
            )}
          </DrawerBody>
          <DrawerFooter>
            <Button colorScheme="green" onClick={() => { setIsAlertOpen(true); }}>Update</Button>
          </DrawerFooter>
        </DrawerContent>
      </Drawer>

      <Modal isOpen={openPasswordModal} onClose={() => { setOpenPasswordModal(false); setSelectedEmpCredential(null); }} isCentered size="xl">
        <ModalOverlay />
        <ModalContent borderRadius="2xl" boxShadow="xl" className="font-poppins text_md text_regular">
          <ModalHeader textAlign="center" fontWeight="600" fontSize="xl" borderBottom="1px solid #E2E8F0" py={3}>Employee Credential</ModalHeader>
          <ModalCloseButton />
          <ModalBody py={5}>
            {selectedEmpCredential ? (
              <Box display="flex" flexDirection="column" gap={4} px={2}>
                <Box display="flex" justifyContent="space-between" alignItems="center">
                  <Text fontWeight="500" color="gray.600">Username:</Text>
                  <Text color="blue.600" fontWeight="600">{selectedEmpCredential.email}</Text>
                </Box>
                <Box display="flex" justifyContent="space-between" alignItems="center">
                  <Text fontWeight="500" color="gray.600">Password:</Text>
                  <Text color="green.600" fontWeight="600">{selectedEmpCredential.login_Password}</Text>
                </Box>
              </Box>
            ) : (
              <Text textAlign="center" color="gray.500">No credentials available.</Text>
            )}
          </ModalBody>
          <ModalFooter borderTop="1px solid #E2E8F0" display="flex" justifyContent="space-between"></ModalFooter>
        </ModalContent>
      </Modal>

      <Modal isOpen={isSupportModalOpen} onClose={() => setIsSupportModalOpen(false)} isCentered size="lg">
        <ModalOverlay />
        <ModalContent className="font-poppins text_md text_regular">
          <ModalHeader>Assign Support Groups</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <MultiSelectMenu label="Select Support Groups" options={assignGroups} selectedValues={selectedSupportGroups} setSelectedValues={setSelectedSupportGroups} labelKey="assign_Group_Name" valueKey="assign_Group_Id" />
          </ModalBody>
          <ModalFooter>
            <Button colorScheme="green" onClick={submitSupportGroup}>Assign</Button>
          </ModalFooter>
        </ModalContent>
      </Modal>

      <Modal isOpen={isHistoryModalOpen} onClose={() => setIsHistoryModalOpen(false)} isCentered size="5xl" scrollBehavior="inside">
        <ModalOverlay />
        <ModalContent className="font-poppins text_md text_regular">
          <ModalHeader borderBottom="1px solid #E2E8F0">
            Role Change History
            {roleChangeHistory.length > 0 && (
              <Text fontSize="sm" color="gray.500" fontWeight="400">
                {roleChangeHistory[0]?.employee_Name} (ID: {roleChangeHistory[0]?.login_ID})
              </Text>
            )}
          </ModalHeader>
          <ModalCloseButton />
          <ModalBody py={4}>
            {historyLoading ? (
              <Center py={10}><Spinner thickness="4px" speed="0.65s" emptyColor="gray.200" color="#006838" size="xl" /></Center>
            ) : roleChangeHistory.length === 0 ? (
              <Text textAlign="center" color="gray.500">No history found.</Text>
            ) : (
              <TableContainer>
                <Table variant="simple" size="sm">
                  <Thead bg="gray.50">
                    <Tr>
                      <Th>Emp ID</Th><Th>Employee</Th><Th>Changed By</Th><Th>Old Roles</Th><Th>New Roles</Th><Th>Added</Th><Th>Removed</Th><Th>Date & Time</Th>
                    </Tr>
                  </Thead>
                  <Tbody>
                    {roleChangeHistory.map((log, index) => (
                      <Tr key={index} _hover={{ bg: "gray.50" }}>
                        <Td>{log.login_ID}</Td>
                        <Td fontWeight="500">{log.employee_Name}</Td>
                        <Td>{log.changed_By}</Td>
                        <Td><Wrap>{log.old_Roles?.map((r: string, i: number) => (<WrapItem key={i}><Tag size="sm" colorScheme="gray"><TagLabel>{r}</TagLabel></Tag></WrapItem>))}</Wrap></Td>
                        <Td><Wrap>{log.new_Roles?.map((r: string, i: number) => (<WrapItem key={i}><Tag size="sm" colorScheme="blue"><TagLabel>{r}</TagLabel></Tag></WrapItem>))}</Wrap></Td>
                        <Td><Wrap>{log.added_Roles?.map((r: string, i: number) => (<WrapItem key={i}><Tag size="sm" colorScheme="green"><TagLabel>+ {r}</TagLabel></Tag></WrapItem>))}</Wrap></Td>
                        <Td><Wrap>{log.removed_Roles?.map((r: string, i: number) => (<WrapItem key={i}><Tag size="sm" colorScheme="red"><TagLabel>- {r}</TagLabel></Tag></WrapItem>))}</Wrap></Td>
                        <Td whiteSpace="nowrap">{new Date(log.changed_At).toLocaleString('en-IN', { day: '2-digit', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit' })}</Td>
                      </Tr>
                    ))}
                  </Tbody>
                </Table>
              </TableContainer>
            )}
          </ModalBody>
          <ModalFooter borderTop="1px solid #E2E8F0">
            <Button onClick={() => setIsHistoryModalOpen(false)}>Close</Button>
          </ModalFooter>
        </ModalContent>
      </Modal>

      <AlertCard isOpen={isAlertOpen} onClose={() => setIsAlertOpen(false)} onConfirm={handleConfirmUpdate} title="Update Role" description="Are you Sure you want to update role?" confirmLabel='Confirm' cancelLabel='Cancel' colorScheme='green' />
    </MyDiv>
  );
};

export default Users;